import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService {

  constructor() { }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    debugger;
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);

    var C1 = XLSX.utils.decode_col("A");
    var C2 = XLSX.utils.decode_col("B");
    var C3 = XLSX.utils.decode_col("C");
    var C4 = XLSX.utils.decode_col("D");
    var C5 = XLSX.utils.decode_col("E");
    var C6 = XLSX.utils.decode_col("F");

    var C7 = XLSX.utils.decode_col("G");
    var C8 = XLSX.utils.decode_col("H");
    var C9 = XLSX.utils.decode_col("I");
    var C10 = XLSX.utils.decode_col("J");
    var C11 = XLSX.utils.decode_col("K");


    var fmt = '@'; /* for text format*/
    var range = XLSX.utils.decode_range(worksheet['!ref']);
    for (var i = range.s.r + 1; i <= range.e.r; ++i) {
      /* find the data cell (range.s.r + 1 skips the header row of the worksheet) */

      var ref1 = XLSX.utils.encode_cell({ r: i, c: C1 });
      var ref2 = XLSX.utils.encode_cell({ r: i, c: C2 });
      var ref3 = XLSX.utils.encode_cell({ r: i, c: C3 });
      var ref4 = XLSX.utils.encode_cell({ r: i, c: C4 });
      var ref5 = XLSX.utils.encode_cell({ r: i, c: C5 });
      var ref6 = XLSX.utils.encode_cell({ r: i, c: C6 });
      var ref7 = XLSX.utils.encode_cell({ r: i, c: C7 });
      var ref8 = XLSX.utils.encode_cell({ r: i, c: C8 });
      var ref9 = XLSX.utils.encode_cell({ r: i, c: C9 });
      var ref10 = XLSX.utils.encode_cell({ r: i, c: C10 });
      var ref11 = XLSX.utils.encode_cell({ r: i, c: C11 });
     
      /* if the particular row did not contain data for the column, the cell will not be generated */

      if(worksheet[ref1] != undefined) 
      {
        worksheet[ref1].z = fmt;
      }
      if(worksheet[ref2] != undefined) 
      {
        worksheet[ref2].z = fmt;
      }
      if(worksheet[ref3] != undefined) 
      {
        worksheet[ref3].z = fmt;
      }
      if(worksheet[ref4] != undefined) 
      {
        worksheet[ref4].z = fmt;
      }
      if(worksheet[ref5] != undefined) 
      {
        worksheet[ref5].z = fmt;
      }
      if(worksheet[ref6] != undefined) 
      {
        worksheet[ref6].z = fmt;
      }
      if(worksheet[ref7] != undefined) 
      {
        worksheet[ref7].z = fmt;
      }
      if(worksheet[ref8] != undefined) 
      {
        worksheet[ref8].z = fmt;
      }
      if(worksheet[ref9] != undefined) 
      {
        worksheet[ref9].z = fmt;
      }
      if
      (worksheet[ref10] != undefined) 
      {
        worksheet[ref10].z = fmt;
      }
      if(worksheet[ref11] != undefined) 
      {
        worksheet[ref11].z = fmt;
      }
      // if(!worksheet[ref2]) continue;
      // if(!worksheet[ref3]) continue;

      /* `.t == "s"` for Text cells */
      // if(worksheet[ref1].t != "s") continue;
      // if(worksheet[ref2].t != "s") continue;

      /* assign the `.z` Text format */
      // worksheet[ref1].z = fmt;
      // worksheet[ref2].z = fmt;
      // worksheet[ref3].z = fmt;
    }
    debugger

    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array', Props: { Author: 'Cellde' } });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    debugger;
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    let date = new Date();
    //     const monthNames = ["January", "February", "March", "April", "May", "June",
    // "July", "August", "September", "October", "November", "December"];
    debugger;
    FileSaver.saveAs(data, fileName + '_' + ((("0" + date.getDate()).slice(-2)) + (("0" + (date.getMonth() + 1)).slice(-2)) + date.getFullYear() + ("0" + date.getHours()).slice(-2) + ("0" + date.getMinutes()).slice(-2)) + EXCEL_EXTENSION);
  }

}